export default __webpack_public_path__ + "static/media/i-interior-connect.e45e508a.svg";